<template>
  <button
      class="btn orcaBtn admin-toggle-btn"
      :class="{ active }"
      @click="toggleAdmin"
      :disabled="disabled"
  >
    <i v-if="!active" class="fas fa-lock"></i>
    <i v-else class="fas fa-lock-open"></i>
    <span style="padding-left: 5px;">ADVANCED</span>
  </button>
</template>

<script>
export default {
  name: "AdminToggleButton",

  props: {
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, required: true },
    toggleAdmin: { type: Function, required: true }
  }
};
</script>

<style scoped>
.admin-toggle-btn {
  transition: background 0.15s ease, box-shadow 0.15s ease;
  min-width: 170px;
  width: 170px;
}

/* Pressed (mouse down) effect */
.admin-toggle-btn:active {
  background: #e6b800;         /* slightly darker yellow */
}

/* When admin state active (padlock open) */
.admin-toggle-btn.active {
  background: #e6b800;         /* darker base */
  box-shadow: inset 0 0 5px rgba(0,0,0,0.4); /* subtle pressed inset look */
}

.admin-toggle-btn i {
  color: white;

}
</style>
